import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { RightSideTrailType, RightSideTrailInitialStateType } from "../../../models/right-side-trail-model";
import NewsArticlesRightSideBooksService from '../../../services/right-side/news-articles-right-side-books.service';

const initialState: RightSideTrailInitialStateType = {
    rightSideFeaturedBooksData: [],
    rightSideFeaturedLearningData: [],
    rightSideTrendingNewsData: [],
    rightSidePopularEventsData: [],
    Loading: false,
    Error: undefined,
};


export const retrieveNewsArticlesRightSideBooks = createAsyncThunk('NewsArticlesRightSideBooks/retrieve',
    async (productPath: string, { rejectWithValue }) => {
        try {

            const response = await NewsArticlesRightSideBooksService.getNewsArticlesRightSideBooksService(productPath)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const NewsArticlesRightSideBooksSlice = createSlice({
    name: 'NewsArticlesRightSideBooks',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveNewsArticlesRightSideBooks.pending, (state) => {
                state.Loading = true;
            })
            .addCase(retrieveNewsArticlesRightSideBooks.fulfilled, (state, action) => {
                if (action.payload) {
                    state.Loading = false;
                    state.rightSideFeaturedBooksData = action.payload as RightSideTrailType[];
                }
            })
            .addCase(retrieveNewsArticlesRightSideBooks.rejected, (state, { payload }) => {
                state.Loading = false;
                state.Error = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default NewsArticlesRightSideBooksSlice.reducer;
